import React, { useEffect, useState } from 'react'
import { useOutletContext, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import { RiPagesLine } from 'react-icons/ri'
import { MdOutlineCallToAction } from "react-icons/md"

import useFetchData from 'Shared/Hooks/useFetchData'
import DataTable from 'Shared/Components/DataTable'
import { apiUrl } from 'Shared/utils'
import moment from 'moment'
import useLoop from 'Shared/Hooks/useLoop'

const NetworkRouter = () => {
  const { profile, role, setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { send } = useFetchData()
  const navigate = useNavigate()

  const [data, setData] = useState([])

  const loadData = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/network_router/router_list`,
      returnType: "json"
    })

    setData(body.map((i) => ({
      "device_id": i["device_id"],
      "name": i["device_name"],
      "ip": i["ip"],
      "last_update": i["last_update"] ? moment(i["last_update"]).format("YYYY-MM-DD HH:mm:ss") : null,
      "strength": i["csq"] ? `${i["csq"]} / ${-113 + (parseInt(i["csq"]) * 2)} dBm` : null,
      "online": (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
          <span style={{ height: "15px", width: "15px", backgroundColor: (moment().diff(moment(i["last_update"]), 'seconds') < 300) ? "green" : "red", borderRadius: "50%" }}></span>
        </div>
      ),
      "url": i["url"],
    })))
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await loadData()

      setPageLoading(false)
    }

    init()
  }, [])

  useLoop(loadData, 30000)

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={data} count={null}
              columns={{
                "online": { "label": t("general_online"), "sorting": false, "nowrap": true },
                "name": { "label": t("general_deviceName"), "sorting": false, "nowrap": true },
                "device_id": { "label": t("roter_mac"), "sorting": false, "nowrap": true },
                "ip": { "label": t("router_ip"), "sorting": false, "nowrap": true },
                "strength": { "label": t("router_strength"), "sorting": false, "nowrap": true },
                "last_update": { "label": t("general_lastUpdate"), "sorting": false, "nowrap": true },
              }}
              renderActions={(row) => { return [
                {icon: <RiPagesLine size={20}/>, text: t("router_adminPage"), onClick: function(row) { window.open(row["url"]) }},
                {icon: <MdOutlineCallToAction size={20}/>, text: t("router_detail"), onClick: function(row) { navigate(`./${row["device_id"]}`) }},
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 
  </>)
}

export default NetworkRouter
